import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom'
import Header from './header';
import Home from './dashboard';
import SideBar from './sidebar';
import Product from './view/product'
import Category from './view/category';
import Order from './view/order';
import Customer from './view/customer';
import User from './view/user';
import Payment from './view/payment';
import Preorder from './view/preorder';
import Cron from './view/cron';
import FileUpload from './view/fileuploads';
import Wallet from './view/wallet';
import Report from './view/report';
import AppConfig from './view/config';
import Offer from './view/offer';
import SpecialProduct from './view/special';
// import Ticket from './view/ticket';


export default class rootRoutes extends Component {
  render() {
    const { match } = this.props;
    return (
      <main>
        <Header />
        <div id="layoutSidenav">
          <SideBar />
          <Switch>
            <Route exact path={[`${match.path}/home`, `${match.path}`]} component={Home} />
            <Route path={`${match.path}/product`} component={Product} />
            <Route path={`${match.path}/category`} component={Category} />
            <Route path={`${match.path}/order`} component={Order} />
            <Route path={`${match.path}/preorder`} component={Preorder} />
            <Route path={`${match.path}/cron`} component={Cron} />
            <Route path={`${match.path}/customer`} component={Customer} />
            <Route path={`${match.path}/user`} component={User} />
            <Route path={`${match.path}/payment`} component={Payment} />
            <Route path={`${match.path}/uploads`} component={FileUpload} />
            <Route path={`${match.path}/wallet`} component={Wallet} />
            <Route path={`${match.path}/report`} component={Report} />
            <Route path={`${match.path}/config`} component={AppConfig} />
             <Route path={`${match.path}/offer`} component={Offer} />
             <Route path={`${match.path}/special`} component={SpecialProduct} />
            {/* <Route path={`${match.path}/ticket`} component={Ticket} /> */}

          </Switch>
        </div>
      </main>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/admin/rootRoutes.jsx